import React from 'react';
import { X, ZoomIn, Download } from 'lucide-react';

const ImageModal = ({ isOpen, imageUrl, onClose }) => {
    if (!isOpen || !imageUrl) return null;

    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/90 backdrop-blur-md p-4 transition-all duration-300 animate-fade-in"
            onClick={onClose}
        >
            {/* Kapatma Butonu */}
            <button
                onClick={onClose}
                className="absolute top-4 right-4 md:top-6 md:right-6 p-2 md:p-3 text-slate-400 hover:text-white hover:bg-slate-800 rounded-full transition-all z-10"
                title="Kapat (ESC)"
            >
                <X size={28} className="md:w-8 md:h-8" />
            </button>

            {/* Aksiyon Butonları */}
            <div className="absolute top-4 left-4 md:top-6 md:left-6 flex flex-col md:flex-row gap-3 z-10">
                <a
                    href={imageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="flex items-center justify-center gap-2 px-4 py-2.5 bg-slate-800/80 hover:bg-slate-700 text-slate-200 rounded-xl backdrop-blur-md transition-all font-medium text-sm border border-slate-700 shadow-lg hover:shadow-xl"
                    title="Yeni Sekmede Büyüt"
                >
                    <ZoomIn size={18} />
                    <span className="hidden sm:inline">Büyüt</span>
                </a>
                <a
                    href={imageUrl}
                    download
                    onClick={(e) => {
                        e.stopPropagation();
                        // Forcing download instead of opening in browser if possible
                        // Often relying on the 'download' attribute is enough for same-origin URLs
                    }}
                    className="flex items-center justify-center gap-2 px-4 py-2.5 bg-primary-600/90 hover:bg-primary-500 text-white rounded-xl backdrop-blur-md transition-all font-bold text-sm border border-primary-500/50 shadow-lg shadow-primary-500/20 hover:scale-105 active:scale-95"
                    title="Cihaza İndir"
                >
                    <Download size={18} />
                    <span className="hidden sm:inline">İndir</span>
                </a>
            </div>

            {/* Resim */}
            <div
                className="relative flex items-center justify-center p-4 max-w-full max-h-[90vh] animate-slide-up"
                onClick={(e) => e.stopPropagation()}
            >
                <img
                    src={imageUrl}
                    alt="Kredi/Tahsilat Görseli"
                    className="max-h-[85vh] max-w-full object-contain rounded-2xl shadow-2xl ring-1 ring-slate-700"
                />
            </div>
        </div>
    );
};

export default ImageModal;
